export default "__VITE_ASSET__CAej9iHz__"